import moment from 'moment';
import * as yup from 'yup';

const isTextEditorValid = (content: string) => {
  const strippedContent = content.replace(/<(.|\n)*?>/g, '').trim();
  return strippedContent.length > 0;
};

export const formSchemaFn = (
  isActionEdit: boolean,
  isNotPermissionEdit: boolean,
) =>
  yup.object().shape({
    headerTitle: yup
      .string()
      .required('コンテンツ名が入力されていません。')
      .max(100, 'コンテンツ名は100文字以内で入力してください。'),
    titleContent: yup
      .string()
      .required('詳細画面表示タイトルが入力されていません。')
      .max(100, '詳細画面表示タイトルは100文字以内で入力してください。'),
    title: yup
      .string()
      .required('コンテンツ見出しが入力されていません。')
      .max(100, 'コンテンツ見出しは100文字以内で入力してください。'),
    content: yup
      .string()
      .test('is-valid-message', '本文は未入力です。', (value) =>
        isTextEditorValid(value || ''),
      )
      .required('本文は未入力です。')
      .max(10000, '本文は10000文字以内で入力してください。'),
    publicAt: yup
      .date()
      .required('配信日時を選択してください。')
      .when(['status'], ([status], schema) => {
        if (!status) {
          return schema;
        }
        return schema.min(
          moment().add(1, 'minute').startOf('minute').toDate(),
          isActionEdit
            ? '配信日時が過去の日時なので、カレンダー投稿を更新できませんでした。'
            : '配信日時が過去の日時なので、カレンダー投稿を作成できませんでした。',
        );
      }),
    attachment: yup
      .string()
      .test(
        'check-images',
        'コンテンツ画像をアップロードしてください。',
        (_, context) => {
          const images = context.parent.images || [];
          return images.some((image: any) => image !== null);
        },
      ),
    iconAttachment: yup
      .string()
      .test(
        'check-icons',
        'アイコン画像をアップロードしてください。',
        (_, context) => {
          const icons = context.parent.icons || [];
          return icons.some((icon: any) => icon !== null);
        },
      ),
    // status: yup.boolean().required('バナー画像は未入力です。'),
    talk: yup
      .string()
      .required('ホーム発話が入力されていません。')
      .max(100, 'ホーム発話は100文字以内で入力してください。'),
    timeLine: yup
      .string()
      .required('タイムラインが入力されていません。')
      .max(100, 'タイムラインは100文字以内で入力してください。'),
    message: yup
      .string()
      .required('プッシュ通知が入力されていません。')
      .max(100, 'プッシュ通知は100文字以内で入力してください。'),
  } as any);
